// store.js
import { createStore } from 'vuex'
import apiClient from './api';

const store = createStore({
  state: {
    eventData: null,
    eventDataError: null,
    agentsDataError: null,
    agentsData: null,
    engine: null,
    service: null,
    leagueData: null,
    leagueDataError: null,
    eventsErrors: {},
    eventId: null,
    isKSP: null,
    apiKey: null,
    market: null,
    isAuthenticated: false,
  },
  mutations: {
    UPSERT_EVENT_ERROR(state, {key, value}) {
      // Add if the key does not exist, update if it does
      state.eventsErrors = {...state.eventsErrors, [key]: value};
    },
    SET_AUTHENTICATED(state, status) {
      state.isAuthenticated = status;
    },
    REMOVE_EVENT_ERROR(state, key) {
      // eslint-disable-next-line no-unused-vars
      const {[key]: _, ...rest} = state.eventsErrors; // Destructure to exclude the key
      state.eventsErrors = rest; // Reassign the dictionary without the key
    },
    SET_EVENT_DATA(state, {data, eventId, generate_for_cache}) {
      if (generate_for_cache === false) {
        state.eventData = data;
        state.isLoadingEventData = false;
        state.eventDataError = null
      }
      if (!state.leagueData) {
        return
      }
      state.leagueData.forEach((event) => {
        if (event.id === eventId) {
          event.mono_data = data.gpt_output_generated_at; // Redefine gpt_generated_at
        }
      });
    },
    SET_EVENT_DATA_ERROR(state, error) {
      state.eventDataError = error;
    },
    SET_AGENTS_DATA(state, data) {
      state.agentsData = data;
      state.eventAgentsError = null
    },
    SET_LEAGUE_DATA(state, data) {
      state.leagueData = data;
      state.leagueDataError = null
    },
    SET_AGENTS_DATA_ERROR(state, error) {
      state.eventAgentsError = error;
    },
    SET_LEAGUE_DATA_ERROR(state, error) {
      state.eventAgentsError = error;
    },
    SET_LOADING_EVENT_DATA(state, loading) {
      state.isLoadingEventData = loading;  // Manage loading state
    },
    setCurrentContent(state, newContent) {
      state.currentContent = newContent;
    },
    SET_LOADING_EVENT_DATA_FAILED(state, is_error) {
      state.isLoadingEventDataFailed = is_error;  // Manage loading state
    },
    setEventId(state, value) {
      state.eventId = value;
    },
    setApiKey(state, value) {
      state.apiKey = value;
    },
    setMarket(state, value) {
      state.market = value;
    },
    setService(state, value) {
      state.service = value;
    },
    setEngine(state, value) {
      state.engine = value;
    },
    setUseAgents(state, value) {
      state.useAgents = value;
    },
    setIsKsp(state, value) {
      state.isKSP = value;
    },
    setDummy(state, value) {
      state.dummy = value;
    },
  },
  actions: {
    checkAuth({ commit }) {
      const token = sessionStorage.getItem("access_token");
      commit("SET_AUTHENTICATED", !!token);
    },

    fetchLeaguesEvents({commit}, {apiKey, leagueId, market, isKSP}) {
      return new Promise((resolve) => {
        setTimeout(() => {
          let url = `/league_events?api_key=${apiKey}&league_id=${leagueId}&market=${market}`
          if (isKSP) url += '&is_ksp=1';
          apiClient.get(url).then(response => {
            commit('SET_LEAGUE_DATA', response.data);
            resolve()
          }).catch(error => {
            let error_data = error.response ? error.response.data : error.message;
            commit('SET_LEAGUE_DATA_ERROR', error_data)
          });
        }, 1000);
      });
    },
    fetchAgentsWorkflow({commit}, {apiKey}) {
      setTimeout(() => {
        let url = `/agents?api_key=${apiKey}`
        apiClient.get(url).then(response => {
          commit('SET_AGENTS_DATA', response.data);
        }).catch(error => {
          let error_data = null;
          if (error.response) {
            error_data = error.response.data
          } else {
            error_data = error.message
          }
          commit('SET_AGENTS_DATA_ERROR', error_data)
        });
      }, 1000);
    },
    fetchEventData({commit}, {eventId, market, apiKey, service, engine, use_agents, force_service, initial=false, generate_for_cache = false, isKSP = false, dummy = false}) {
      commit('SET_LOADING_EVENT_DATA_FAILED', false);
        if (initial) {
            commit('SET_LOADING_EVENT_DATA', true);  // Set loading to true before fetching
        }
      // Simulate fetch operation
      return new Promise((resolve) => {
        setTimeout(() => {
          let url = `/blog_json?event_id=${eventId}&market=${market}&api_key=${apiKey}`
          if (service !== null && service !== undefined) url += `&service=${service}`;
          if (engine !== null && engine !== undefined) url += `&engine=${engine}`;
          if (dummy) url += `&dummy=1`;
          if (force_service !== null && force_service !== undefined) {
            url += `&${force_service}=1`;
          } else if (use_agents !== null && use_agents !== undefined) {
            url += `&use_agents=${use_agents}`;
          }
          if (isKSP) url += '&is_ksp=1';
          apiClient.get(url).then(response => {
            commit('SET_EVENT_DATA', {data: response.data, eventId, generate_for_cache});
            commit('REMOVE_EVENT_ERROR', eventId)
            resolve();
          }).catch(error => {
            let error_data = null;
            if (error.response) {
              error_data = error.response.data
            } else {
              error_data = error.message
            }
            if (generate_for_cache===false){
              commit('SET_EVENT_DATA_ERROR', error_data)
              commit('SET_LOADING_EVENT_DATA_FAILED', true);
            }
            commit('UPSERT_EVENT_ERROR', {key: eventId, value: error_data})

            commit('SET_LOADING_EVENT_DATA', false);  // Ensure loading is set to false on error
            resolve()
          });
        }, 1000);
      });
    }
  }
});
export default store;